/**
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   MessageFormLoadingFallback.styles.ts
 * This is an autogenerated file.
 */

import { css } from '@emotion/react'

export const messageForm = css`
  width: 100%;
  height: 531px;
  @media (min-width: 771px) {
    min-width: 320px;
  }
  @media (max-width: 640px) {
    height: 378px;
  }
`
